import * as React from 'react'

import { observer } from 'mobx-react'

import { IScreen } from '~/client/graph'
import NumberSelector from '~/client/src/desktop/components/NumberSelector/NumberSelector'
import { Checkbox } from '~/client/src/shared/components/shadcn-ui/checkbox'
import KnownTranslatorKeys from '~/client/src/shared/localization/knownTranslatorKeys'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { padWithZero } from '~/client/src/shared/stores/ui/ProjectDate.store'

import PresentationSetUpStore from '../PresentationSetUp.store'

interface IProps {
  screen: IScreen
  titleTranslatorKey: KnownTranslatorKeys
  descriptionTranslatorKey: KnownTranslatorKeys
  imageSrc: string
  store: PresentationSetUpStore
}

const SECONDS_IN_MINUTE = 60

const DURATION = {
  MIN: 15,
  STEP: 15,
}
const ORDER_MIN_VALUE = 1

@observer
export default class PresentationScreenComponent extends React.Component<IProps> {
  public render() {
    const { imageSrc, titleTranslatorKey, descriptionTranslatorKey, screen } =
      this.props
    const { isShown, duration, order } = screen
    const { availableScreensCount: screensCount } = this.props.store

    return (
      <div className="tw:p-[10px] tw:pb-[50px] tw:bg-background">
        <img
          className="tw:pointer-events-none tw:w-full tw:border tw:border-solid tw:border-border"
          src={imageSrc}
        />
        <div className="tw:text-body-md tw:text-foreground tw:pt-2.5">
          <Checkbox
            checked={isShown}
            onCheckedChange={() => this.onVisibilityChanged()}
          />
          <span>{Localization.getText(titleTranslatorKey)}</span>
        </div>
        <div className="tw:text-body-md tw:text-foreground tw:pt-2.5">
          {Localization.getText(descriptionTranslatorKey)}
        </div>
        {isShown && (
          <div className="tw:pt-2.5">
            <div className="tw:inline-block tw:mr-5">
              <div className="tw:text-body-md tw:text-foreground tw:inline-block tw:mr-[5px]">
                {Localization.translator.order_noun}
              </div>
              <NumberSelector
                value={order}
                min={ORDER_MIN_VALUE}
                max={screensCount}
                numberFormatter={this.getOrderNumberString}
                onChange={this.onOrderChanged}
              />
            </div>
            <div className="tw:inline-block tw:mr-5">
              <div className="tw:text-body-md tw:text-foreground tw:inline-block tw:mr-[5px]">
                {Localization.translator.display}
              </div>
              <NumberSelector
                value={duration}
                min={DURATION.MIN}
                step={DURATION.STEP}
                numberFormatter={this.getDurationString}
                onChange={this.onDurationChanged}
              />
            </div>
          </div>
        )}
      </div>
    )
  }

  private onVisibilityChanged = () => {
    const { store, screen } = this.props
    store.onItemVisibilityChanged(screen.key, !screen.isShown)
  }

  private onDurationChanged = (newValue: number) => {
    const { store, screen } = this.props
    store.onItemDurationChanged(screen.key, newValue)
  }

  private onOrderChanged = (newValue: number) => {
    const { store, screen } = this.props
    store.onItemOrderChanged(screen.order - 1, newValue - 1)
  }

  private getDurationString(value: number) {
    const minutesCount = Math.floor(value / SECONDS_IN_MINUTE)
    const secondsCount = value % SECONDS_IN_MINUTE
    const secondsString = padWithZero(secondsCount)
    return `${minutesCount}:${secondsString}`
  }

  private getOrderNumberString(value: number) {
    return Localization.translator.order_number(value)
  }
}
